import React from 'react';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import BreederApplicationContainer from 'dpl/join_as_breeder/containers/BreederApplicationContainer';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function JoinAsBreederCallout() {
  const { isFetching, isBreeder } = useCurrentUser();

  if (isFetching || isBreeder) {
    return null;
  }

  return (
    <div className="PrismicJoinAsBreederCallout container tc purple">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <div className="ph4 pt5 pb4 pv13-lg br1 ba b--purple bw1">
            <h3 className="PrismicActionCallout__headline mb4 mb6-lg purple f5">
              Join our Good Breeder community
            </h3>
            <div className="row">
              <div className="col-lg-10 col-xl-8 center mb6">
                <p>
                  Are you a responsible breeder? We&apos;d love to recognize
                  you. Connect directly with informed buyers, get access to free
                  benefits, and more.
                </p>
              </div>
            </div>
            <BreederApplicationContainer className="w-100 w-auto-ns pv3 ph20-lg br1" />
          </div>
        </div>
      </div>
    </div>
  );
}
